
import { mapGetters } from 'vuex'
import { loadLink, parseTime, setHistoryList } from '~/utils/validate'
import { getReleaseTimeString ,formatCount} from '~/utils'
import countTo from 'vue-count-to'
export default {
    components: {
        countTo
    },
    computed: {
        ...mapGetters({
            gameList: 'game/gameList',
            severTime: 'severTime',
            token: 'user/token'
        }),
        curMonth() {
            const currentMonth = new Date().getMonth() + 1
            return currentMonth
        }
    },
    data() {
        return {
            activeName: 'first',
            searchName: '',
            searchNum: '',
            // topItemIndex: null,
            FIND_CASE: [],
            NORMAL: [],
            anchorList: [],
            // gameData: [],
            // topGoodsList: [],
            questionPageList: [],
            topListLoading: false,
            gameId: null,
            htmlEl: null,
            // wantNum:0,
            // seenNum:0,
            // wantBuyText:'',
            // seenText:''
            // gameDataHOT: [],
        }
    },
    //示例代码
    async asyncData({ app, params, store, route }) {
        let tabsList = []
        let result, banner, topList
        const now = new Date()
        now.setDate(now.getDate() - 1) // 设置为昨天
        now.setHours(0, 0, 0, 0) // 将时间设为 00:00:00

        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0') // 月份从0开始，需要加1
        const date = String(now.getDate()).padStart(2, '0')
        const yesterdayDate = `${year}-${month}-${date} 00:00:00`
        // 客户端
        if (!process.server) {
            const token = store.getters['user/token']
            // 没有token
            if(!token){
                try {
                    // 没有token 调用优先调用redis缓存
                    const indexDataSSR = await app.$api.getIndex()
                    // result = indexDataSSR.result
                    banner = indexDataSSR.banner
                    topList = indexDataSSR.topList
                } catch (err) {
                    // 没有token 调用redis缓存失败 调用后端接口
                    // result = await app.$api.transactionPage({ action: { transactionTime: yesterdayDate } })
                    banner = await app.$api.bannerList()
                    topList = await app.$api.getAllTopGoods({ action: {} })
                }
            } else {
                // 有token 调用后端接口
                try {
                    banner = await app.$api.bannerList()
                    topList = await app.$api.getAllTopGoods({ action: {} })
                } catch (error) {
                    console.error('error', error.message);

                }
            }
            const tabs = await app.$api.gameAllCatalogueSSR()
            if (!tabs.success) {
                console.error('tabs-gameAllCatalogueSSR-un-success', tabs)
            }

            const tabsData = Array.isArray(tabs.data) ? tabs.data : []
            tabsList = [{ name: '热门游戏', id: 'HOT' }, ...tabsData, { id: 'NEW', name: '最近浏览' }]
        } else {
            // 服务端
            banner = await app.$api.bannerList()
            topList = await app.$api.getAllTopGoods({ action: {} })
            const tabs = await app.$api.gameAllCatalogue()
            if (!tabs.success) {
                console.error('tabs-gameAllCatalogue-un-success', tabs)
            }
            const tabsData = Array.isArray(tabs.data) ? tabs.data : []
            tabsList = [{ name: '热门游戏', id: 'HOT' }, ...tabsData, { id: 'NEW', name: '最近浏览' }]
        }
        result = await app.$api.transactionPage({ action: { transactionTime: yesterdayDate } })
        const anchorPage = await app.$api.anchorPage({
            action: {},
            page: 1,
            pageSize: 10
        })
        if (!anchorPage.success) {
            console.error('anchorPage-request-un-success', anchorPage)
        }

        const gameData = await app.$api.gamePopular({
            action: {}
        })
        const gameRecommendData = await app.$api.homeRecommendGame({ action: {} })
        const homeCountData = await app.$api.transactionStatistics()
        store.commit('game/SET_GOODS_DEAL_COUNT', homeCountData?.data?.safeTransactionNumber)
        const list = [...topList?.data[0].topGoodsList]
        const gameId = topList?.data[0].id
        // 交易榜
        const monthTradeData = await app.$api.monthsTradesPageAPI({ action: {}, pageSize: 3 })
        // 昨日成交榜
        const yesterdayData = await app.$api.yesterdayDealGameAPI()
        // 注意js里面的getMonth是从0开始的

        return {
            BAIDU_URL: process.env.BAIDU_URL + route.path,
            BAIDU_DATE: app.$formattedDateTime(),
            BAIDU_PUSH_DATE: anchorPage.data?.records?.length > 0 ? anchorPage.data.records[0].createTime.replace(' ', 'T') : '',
            tabsList,
            gameDataHOT: gameData?.data || [],
            transactionNewList: result?.data?.records || [],
            bannerList: banner?.data || [],
            gameData: topList ? topList?.data?.splice(0, 7) : [],
            topItemIndex: gameId,
            anchorList: anchorPage.data?.records || [],
            monthTradeList: monthTradeData ? monthTradeData?.data?.records?.splice(0, 3) : [],
            yesterdayList: yesterdayData ? yesterdayData?.data?.games?.splice(0, 6) : [],
            topGoodsList: list.map(item => {
                return {
                    ...item,
                    goodsImg: item.goodsImg && item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg')
                }
            }),
            homeCount: homeCountData?.data,
            gameRecommend: gameRecommendData?.data || []
        }
    },
    head() {
        return {
            title: '盼之代售-玩家虚拟财产的守护者-游戏账号交易平台',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: '盼之代售，专业正规的游戏账号交易平台，提供网游交易售卖，手游账号买号卖号服务。王者荣耀账号出售，穿越火线cf卖号交易，英雄联盟lol买号交易，原神账号交易充值等。'
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: '游戏账号交易，买游戏账号，卖游戏账号，盼之代售'
                }
            ],
            script: [
                {
                    hid: 'ldjson-schema',
                    innerHTML: `{"@context": "https://ziyuan.baidu.com/contexts/cambrian.jsonid","@id":"https://${this.BAIDU_URL}","pubDate": "${this.BAIDU_PUSH_DATE}","upDate": "${this.BAIDU_DATE}"}`,
                    type: 'application/ld+json'
                }
            ],
            __dangerouslyDisableSanitizersByTagID: {
                'ldjson-schema': ['innerHTML']
            }
        }
    },
    methods: {
        releaseTimeString(onStandTime) {
            return getReleaseTimeString(onStandTime)
        },
        // 主播切换
        handleAnchorPrev() {
            this.$refs.anchorSwiperRef.showPrev()
        },
        handleAnchorNext() {
            this.$refs.anchorSwiperRef.showNext()
        },
        gotoGameList(item) {
            // this.$store.commit('game/SET_INDEX_RECOMMEND_FILTER', item.searchField)
            this.$store.commit('game/SET_INDEX_GAME_FILTER', item)
            this.$router.push(`/goodsList/${item.gameId}/6`)
        },
        // 降价
        getReducePricecomputed(goods) {
            if (!goods.priceUpdateTime) return
            const currentTimestamp = new Date().getTime()
            // 大于72小时的商品降价不显示
            const timeDiff = currentTimestamp - new Date(goods.priceUpdateTime).getTime()
            if (timeDiff > 72 * 60 * 60 * 1000) {
                return 0
            }
            if (!goods.originalPrice || !goods.price) return 0
            return (goods.originalPrice - goods.price).toFixed(2)
        },
        goDetails(value) {
            let ga = {}
            this.gameData.map(item => {
                if (item.id === this.topItemIndex) {
                    ga = { ...item, goodsCatalogueId: 6 }
                }
            })
            setHistoryList(ga)
            let _arr = JSON.parse(window.localStorage.getItem('HistoryList')) || []
            if (_arr.length) {
                _arr.map((vo, key) => {
                    if (vo.id === this.topItemIndex) {
                        _arr.splice(key, 1)
                    }
                })
            }
            _arr.unshift(ga)
            window.localStorage.setItem('HistoryList', JSON.stringify(_arr))
            this.$router.push({
                name: `goodsDetails`,
                params: {
                    goodsNo: value.goodsNo,
                    goodsCatalogueId: value.goodsCatalogueId
                }
            })
        },
        handleMoreAccount(item) {
            window.open(`/goodsList/${item.gameInfo.id}/6`)
        },
        gotoGameDetail(game) {
            window.open(`/goodsDetails/${game.goodsNo}/6?from=${encodeURIComponent('首页')}`)
        },
        // 客服验证
        selNum(type) {
            if (type === 'blackNumber') {
                // this.$router.push("/article?title=黑号查询&number=" + this.searchNum);
                this.$router.push('/blackSign')

                return
            }
            if (!this.searchName) {
                this.$message.error('请输入客服QQ')
                this.$nextTick(() => {
                    this.$refs['kf_qq'].focus()
                })
                return
            }
            let p = { action: { account: this.searchName } }
            this.$api.checkNumber(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                if (res.data.result === 'IS_CUSTOMER_SERVICE') {
                    // 数字验证
                    let reg = new RegExp('^[0-9]*$')
                    if (reg.test(this.searchName)) {
                        this.$alert(`当前账号为盼之代售官方号<br/><img src="https://oss.pzds.com/v2phone/48d9e5bec42c309ecc6fdf2ea641d87.jpg" alt="">`, '成功', {
                            confirmButtonText: '确定',
                            dangerouslyUseHTMLString: true,
                            type: 'success'
                        })
                        return
                    }
                    this.$alert(`当前账号为盼之代售官方号`, '成功', {
                        confirmButtonText: '确定',
                        dangerouslyUseHTMLString: true,
                        type: 'success'
                    })
                    return
                    // this.$message.success(res.data.resultName)
                }
                this.$alert(res.data.resultName, '警告', {
                    confirmButtonText: '确定',
                    type: 'error'
                })
                // this.$message.error(res.data.resultName)
            })
        },
        // 追回案例、
        getNews() {
            let p = { action: { type: 'FIND_CASE' }, page: 1, pageSize: 3 }
            this.$api.newsPage(p).then(res => {
                this.FIND_CASE = res.data.records
            })
        },
        // 新闻公告
        getPublicNotice() {
            this.$api.articleNewAPI().then(res => {
                if (res.success) {
                    this.NORMAL = res.data?.slice(0, 3) || []
                }
            })
        },

        // 最新问题
        getQuestion() {
            let p = {
                action: {},
                page: 1,
                pageSize: 4
            }
            this.$api.questionPage(p).then(res => {
                this.questionPageList = res.data.records
            })
        },
        /**
         * 顶级账号列表
         * 通过 gameId 来获取
         */
        getGameListByTop() {
            this.topListLoading = true
            let p = {
                action: {
                    gameId: this.topItemIndex,
                    goodsCatalogueId: this.$enum.GOODS_TYPE.ACCOUNT,
                    top: true
                },
                order: 'DESC',
                sort: 'price',
                page: 1,
                pageSize: 12
            }
            console.log('寄哪里了~~~~~~~~~~')
            this.$api.goodsList(p).then(res => {
                this.topListLoading = false
                // if (!res.success) {
                //     this.$message.error(res.info)
                //     return;
                // }
                this.topGoodsList = res.data.records.map(item => {
                    return {
                        ...item,
                        goodsImg: item.goodsImg ? item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg') : ''
                    }
                })
            })
        },
        topItemGameHandler(item) {
            this.topItemIndex = item.id
            this.getGameListByTop()
        },
        async getWantAndSeenNumData(gameRecommend) {
            console.log(gameRecommend,'gameRecommend');
            if (!Array.isArray(gameRecommend) || !gameRecommend.length) {
                return gameRecommend
            }

            // 收集所有商品的goodsNo
            const allGoodsNos = []
            gameRecommend.forEach(group => {
                (group.goodsList || []).forEach(item => {
                    allGoodsNos.push({ goodsNo: item.goodsNo, onStandTime: item.onStandTime })
                })
            })
            if (!allGoodsNos.length) return
            try {
                const res = await this.$api.getGoodsWantAndSeenNum({ action: allGoodsNos })
                if (!(res?.success && Array.isArray(res.data))) return

                const map = new Map(res.data.map(d => [d.goodsNo, d]))

                gameRecommend.forEach(group => {
                    (group.goodsList || []).forEach(goods => {
                        const d = map.get(goods.goodsNo)
                        if (d) {
                            this.$set(goods, 'wantNum', d.wantNum || 0)
                            this.$set(goods, 'seenNum', d.seenNum || 0)
                            this.$set(goods, 'wantBuyText', formatCount(d.wantNum || 0))
                            this.$set(goods, 'seenText', formatCount(d.seenNum || 0))
                        }
                    })
                })

                this.gameRecommend = [...this.gameRecommend]
            } catch (e) {
                console.error('获取商品浏览和想要数据失败:', e)
            }
        }
    },
    async mounted() {
        setTimeout(() => {
            window._czc && window._czc.push(['_trackEvent', '访问量', '首页页面', '首页'])
        }, 1000)
        if(this.gameRecommend.length){
            this.getWantAndSeenNumData(this.gameRecommend)
        }
        //
        // this.gameData = [...this.gameList].splice(0, 7);
        // this.topItemIndex = this.gameData[0].id;

        // this.$store.dispatch("game/GameCateList");
        // this.$store.dispatch("game/GameHotList");
        // this.getGameListByTop();

        this.$store.commit('game/SET_BUY_GOODS_TYPE', '6')
        this.$store.commit('game/SET_GAME_HOT_LIST', this.gameDataHOT)
        this.getPublicNotice()
        this.getNews()
        this.getQuestion()

        loadLink('https://www.pzds.com/')

        // const times = setTimeout(() => {
        //     this.$store.dispatch('AppPublicConfig')
        //     clearTimeout(times)
        // }, 1500)
        this.$store.dispatch('AppPublicConfig')
        this.$store.dispatch('user/UserRestrictMall')
        this.$store.dispatch('user/UserCenterStatistics')
    }
}
